import { useMutation } from '@tanstack/react-query'
import authServices from '../Auth/auth-services'
import services, {
  getRecentProfessionals,
  getConsultationsWithPendingConfirmation,
  getExamsRequests,
} from './services'
import { useConexaQuery } from '@/hooks/useConexaQuery'

export const useRecentProfessionalsQuery = (hasScheduleAttendance: boolean) => {
  return useConexaQuery({
    queryKey: ['get-recent-professionals'],
    service: getRecentProfessionals,
    config: {
      refetchOnWindowFocus: false,
      enabled: hasScheduleAttendance,
      cacheTime: 0,
    },
  })
}

export const useConsultationsWithPendingConfirmation = () => {
  return useConexaQuery({
    queryKey: ['get-consultations-with-pending-confirmation'],
    service: () => getConsultationsWithPendingConfirmation(),
    config: {
      refetchOnWindowFocus: false,
    },
  })
}

export const useExamsRequests = (enabled: boolean) => {
  return useConexaQuery({
    queryKey: ['get-exams-requests'],
    service: () => getExamsRequests(),
    config: {
      enabled,
      refetchOnWindowFocus: false,
      retry: false,
    },
  })
}

export const useGetProfileData = (enabled: boolean) => {
  return useConexaQuery({
    queryKey: ['get-profile-data'],
    service: () => authServices.getUserData(),
    config: {
      refetchOnWindowFocus: false,
      retry: false,
      enabled,
      cacheTime: 0,
    },
  })
}

export const useGetClinicOfficeHours = () => {
  return useMutation({
    mutationFn: (clinicId: number) => services.getClinicOfficeHours(clinicId),
  })
}
